
export const common = {
  // Navigation
  home: '首页',
  products: '产品',
  solutions: '解决方案',
  documentation: '文档',
  support: '支持',
  contact: '联系我们',
  
  // Buttons
  getStarted: '开始使用',
  learnMore: '了解更多',
  viewDocumentation: '查看文档',
  startFreeTrial: '开始免费试用',
  contactSales: '联系销售',
  
  // Company
  companyName: '星允信息 Documogul',
  companyDescription: '现代企业文档智能解决方案的领先提供商。'
};
